import type { ApplicationProfileDto } from "../../types/ApplicationProfileDto";
import type { ApplicationProfileEntity } from "../../types/ApplicationProfileEntity";

export const ApplicationProfileApacEntityToDto = ({ ...rest }: Readonly<ApplicationProfileEntity>): ApplicationProfileDto => {
    return { ...rest, apac: true };
};
